const DEFAULTS = {
  config: {}
};
export {
  DEFAULTS
};
//# sourceMappingURL=defaults.js.map
